/**
 * Created by Rodrigo de Miguel on 25/01/2023.
 */

export const TIPOS_EVENTOS = {
    CLIC: "clic",
    IMPRESION: "impresion",
    PAGEVIEW: "pageview",
    SHARE: "share",
    SEARCH: "search",
};

export const ELEMENTS = {
    ENTITY: {
        ENTITY: "Adopta.Entity",
        LINK_DESCRIPCION: "Adopta.Entity.link_descripcion",
        EMAIL_DESCRIPCION: "Adopta.Entity.email_descripcion",
        TEAMING_BUTTON: "Adopta.Entity.teaming_button",
        RECOMENDACION_ENTITY_SIMILAR: "Adopta.Entity.recomendacion.entity_similar",
        CONTACT_EMAIL: "Adopta.Entity.contact.email",
        SOCIALMEDIA_FACEBOOK: "Adopta.Entity.socialmedia.facebook",
        SOCIALMEDIA_INSTAGRAM: "Adopta.Entity.socialmedia.instagram",
        SOCIALMEDIA_TWITTER: "Adopta.Entity.socialmedia.twitter",
    },
    BUSCADOR: {
        BUSCADOR: "Adopta.BuscadorPetFriendly", // se ha visto una pagina del buscador (puede ser desde google, del buscador, carga directa,...)
        ENTITY: "Adopta.BuscadorPetFriendly.Entity", //impresion en el buscador de una entidad
        LISTING: "Adopta.BuscadorPetFriendly.Buscador.Listing",
        MAP: "Adopta.BuscadorPetFriendly.Buscador.Map",
    },
    PROTECTORA: {
        PROTECTORA: "Adopta.Protectora",
        TEAMING_BUTTON: "Adopta.Protectora.teaming_button",
        LINK_DESCRIPCION: "Adopta.Protectora.link_descripcion",
        EMAIL_DESCRIPCION: "Adopta.Protectora.email_descripcion",
    },
    ANIMAL: {
        ANIMAL: "Adopta.animal",
        LINK_DESCRIPCION: "Adopta.animal.link_descripcion",
        TEAMING_DESCRIPCION: "Adopta.animal.teaming_button",
        EMAIL_DESCRIPCION: "Adopta.animal.email_descripcion",
    },
    ADMIN: {
        PANEL_SERVICIOS: "Adopta.admin.protectora.panel_servicios"
    }
}

export const SOCIAL_MEDIA = {
    FACEBOOK: "facebook",
    WHATSAPP: "whatsapp",
    TWITTER: "twitter",
    TELEGRAM: "telegram",
    COPYLINK: "copylink",
}

export const ELEMENT_PROTECTORA_TEAMING_BUTTON = "teaming_button";
export const ELEMENT_PROTECTORA_LINK_DESCRIPCION = "link_descripcion_protectora";
export const ELEMENT_PROTECTORA_TEAMING_DESCRIPCION = "link_descripcion_teaming_protectora";
export const ELEMENT_PROTECTORA_EMAIL_DESCRIPCION = "email_descripcion_protectora";

export const ELEMENT_ANIMAL_LINK_DESCRIPCION = "link_descripcion_animal";
export const ELEMENT_ANIMAL_TEAMING_DESCRIPCION = "link_descripcion_teaming_animal";
export const ELEMENT_ANIMAL_EMAIL_DESCRIPCION = "email_descripcion_animal";


// export const ELEMENTS_TRACKING = [ELEMENT_PROTECTORA_TEAMING_BUTTON, ELEMENT_PROTECTORA_LINK_DESCRIPCION, ELEMENT_PROTECTORA_TEAMING_DESCRIPCION, ELEMENT_PROTECTORA_EMAIL_DESCRIPCION, ELEMENT_ANIMAL_LINK_DESCRIPCION, ELEMENT_ANIMAL_TEAMING_DESCRIPCION, ELEMENT_ANIMAL_EMAIL_DESCRIPCION];
